<template>
  <li class="list_once">
    <p class="p">如何新增电子合同发起审批流程？</p>
    <p class="text">1.在企业控制台 -- 成员合同审批，您可以点击“新增审批”，点击后将在当前页面打开新增合同发起审批页面，按提示填写相关信息即可。</p>
    <img class="img" src="/images/home/sign_img21.png" alt="">
    <img class="img" src="/images/home/sign_img22.png" alt="">
  </li>
</template>
<script>
  export default {
    data () {
      // 这里存放数据
      return {}
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .list_once {
    font-size: 14px;
    padding: 10px;
    .p {
      font-size: 16px;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
    }
    .img {
      max-width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/helpCenterCom/10_addApprFlow.vue